import { axiosClient } from "@/shared/api/axios-client";
import type { IndicadorImpuestoResumen } from "../utils/detalle-expandible";

/**
 * Detalle de la factura extranjera (subtipo INVOICE) de una solicitud · `GET /api/solicitudes/{id}/invoice`.
 * Solo se tipan los campos que consume la fila expandible (el backend manda además
 * plantilla, conceptos, impuesto y documento de compra, que la tabla ya no muestra).
 */
export interface InvoiceDeSolicitud {
  solicitudId: string;
  folio: string;
  tipo: string | null;
  subtipo: string | null;
  numeroFactura: string | null;
  fechaExpedicion: string | null;
  emisorNombre: string;
  emisorTaxId: string | null;
  emisorDireccion: string | null;
  receptorNombre: string | null;
  receptorRfc: string;
  moneda: string;
  subtotal: number | null;
  importeTotal: number;
  proveedorNumero: number | null;
  proveedorRazonSocial: string | null;
  tienePdf: boolean;
  /** Total de impuestos retenidos extraído por OCR · null si no se reportó (invoices previos al campo) → «—». */
  retencionesImporte: number | null;
  /** Indicador derivado de la tasa del impuesto con el catálogo · null si la tasa es null o no está catalogada. */
  indicador: IndicadorImpuestoResumen | null;
}

export async function obtenerInvoiceDeSolicitud(solicitudId: string): Promise<InvoiceDeSolicitud> {
  const { data } = await axiosClient.get<InvoiceDeSolicitud>(`/api/solicitudes/${solicitudId}/invoice`);
  return data;
}
